"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importDefault(require("react"));
function useQuery() {
    const { search } = (0, react_router_dom_1.useLocation)();
    return react_1.default.useMemo(() => new URLSearchParams(search), [search]);
}
exports.useQuery = useQuery;
